export default "__VITE_ASSET__0a2f3577__"